import { render, staticRenderFns } from "./AcceptService.vue?vue&type=template&id=44995820&scoped=true"
import script from "./AcceptService.vue?vue&type=script&lang=js"
export * from "./AcceptService.vue?vue&type=script&lang=js"
import style0 from "./AcceptService.vue?vue&type=style&index=0&id=44995820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44995820",
  null
  
)

export default component.exports